
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiObjectAton as ObcPoiObjectAtonElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-object-aton/poi-object-aton.js';
 
 
 

 
 export const ObcPoiObjectAton = createComponent({
   react: React,
   tagName: 'obc-poi-object-aton',
   elementClass: ObcPoiObjectAtonElement,
   events: {
     
   }
  });
 
 